// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper-btn-result {
  background-image: linear-gradient(35deg, #CD5BE8 0%, #FFABAB 100%);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 14px;
  margin-block: 32px;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);
  cursor: pointer;
  gap: 23px;
}
.wrapper-btn-result span {
  color: #FFFFFF;
  font-family: Figtree;
  font-size: 12px;
  font-weight: bold;
  line-height: 1.2;
}
@media (min-width: 767px) {
  .wrapper-btn-result {
    padding: 16px;
    font-size: 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/btn-result/index.scss"],"names":[],"mappings":"AAAA;EACI,kEAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,iDAAA;EACA,eAAA;EACA,SAAA;AACJ;AACI;EACI,cAAA;EAEI,oBAAA;EACA,eAAA;EACA,iBAAA;EAEJ,gBAAA;AADR;AAII;EAtBJ;IAuBQ,aAAA;IAEI,eAAA;EAFV;AACF","sourcesContent":[".wrapper-btn-result{\n    background-image: linear-gradient(35deg, #CD5BE8 0%, #FFABAB 100%);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 14px;\n    margin-block: 32px;\n    border-radius: 8px;\n    box-shadow: 0px 4px 8px 0px rgba(20, 46, 82, 0.2);\n    cursor: pointer;\n    gap: 23px;\n\n    span{\n        color: #FFFFFF;\n        font: {\n            family: Figtree;\n            size: 12px;\n            weight: bold;\n        }\n        line-height: 1.2;\n    }\n\n    @media (min-width: 767px){\n        padding: 16px;\n        font: {\n            size: 16px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
